import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DashboardService } from '../../dashboard.service';
import { GtmService } from 'app/services/gtm.service';
import { AuthService } from 'app/auth/auth.service';

@Component({
    selector: 'app-dashboard-header',
    standalone: true,
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        TranslateModule,
        RouterModule,
    ],
    templateUrl: './dashboard-header.component.html',
})
export class DashboardHeaderComponent {
    selectedLanguage: any;
    userData: any;
    @Input() haveNotifications: boolean = false;
    @Output() languageChanged = new EventEmitter<string>();
    @Output() toggleSidebar = new EventEmitter<string>();
    isAuthenticated: boolean = false;
    isDropdownOpen: boolean | string = false;
    gtmTags: any = [];

    constructor(
        private router: Router,
        private translate: TranslateService,
        private _dashService: DashboardService,
        private route: ActivatedRoute,
        private gtmService: GtmService,
        public authService: AuthService,
        private _dashboardService: DashboardService
    ) {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
        this.selectedLanguage = localStorage.getItem('language');
        this.translate.use(this.selectedLanguage);
        this.userData = this._dashService.getUser();
        this.route.url.subscribe((segments) => {
            this.gtmTags = this.gtmService.getHeaderGtmTags(segments);
        });
    }

    toHomePage() {
        this.router.navigate(['']);
    }

    switchLanguage(language: string, fromHeader?: any) {
        this._dashboardService.setLanguage(language);
        this.selectedLanguage = language;
        if (language) {
            localStorage.setItem('language', language);
            localStorage.setItem('switched_language', language);
            let current_url = this.router.url;
            if (current_url.includes('language') && fromHeader) {
                let splitUrl = current_url.split('?');
                let newURL = splitUrl[0] + '?language=' + language;
                window.open(newURL, '_self');
                setTimeout(() => {
                    this.translate.use(language);
                }, 1000);
            } else {
                this.translate.use(language);
            }
        }
    }

    toggleDropdown(e) {
        if (this.isDropdownOpen === e) {
            this.closeDropdown();
            return;
        }
        this.isDropdownOpen = e;
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }
}
